'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@client/ui/components/button.tsx';
import { useAuthState } from '@platform/nextjs/contexts/auth/use-auth-state.ts';
import { useAuthActions } from '@platform/nextjs/contexts/auth/use-auth-actions.ts';

export function PublicHeader() {
  const pathname = usePathname();
  const { isAuthenticated, isLoading } = useAuthState();
  const { signOut } = useAuthActions();

  // Hide header on protected routes (they have their own sidebar navigation)
  if (pathname.startsWith('/sec')) {
    return null;
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center justify-between">
        <Link href="/" className="flex items-center space-x-2">
          <span className="font-bold">QuizManiacs</span>
        </Link>
        <nav className="flex items-center gap-2">
          {!isLoading && (isAuthenticated ? (
            <>
              <Button variant="ghost" asChild>
                <Link href="/sec">Dashboard</Link>
              </Button>
              <Button onClick={() => signOut()}>Log Out</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" asChild>
                <Link href="/login">Login</Link>
              </Button>
              <Button asChild>
                <Link href="/signup">Sign Up</Link>
              </Button>
            </>
          ))}
        </nav>
      </div>
    </header>
  );
}
